var _rect, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExpand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#FDFDFE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2929 18.2929C18.6834 17.9024 19.3166 17.9024 19.7071 18.2929L24 22.5858V20.2C24 19.6477 24.4477 19.2 25 19.2C25.5523 19.2 26 19.6477 26 20.2V25C26 25.1356 25.973 25.2649 25.9241 25.3828C25.8757 25.4999 25.804 25.6096 25.7092 25.705C25.7078 25.7064 25.7064 25.7078 25.705 25.7092C25.6096 25.804 25.4999 25.8757 25.3828 25.9241C25.2649 25.973 25.1356 26 25 26H20.2C19.6477 26 19.2 25.5523 19.2 25C19.2 24.4477 19.6477 24 20.2 24H22.5858L18.2929 19.7071C17.9024 19.3166 17.9024 18.6834 18.2929 18.2929Z",
    fill: "#1F2025"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7071 18.2929C14.0976 18.6834 14.0976 19.3166 13.7071 19.7071L9.41421 24H11.8C12.3523 24 12.8 24.4477 12.8 25C12.8 25.5523 12.3523 26 11.8 26H7C6.86441 26 6.73512 25.973 6.61722 25.9241C6.50014 25.8757 6.3904 25.804 6.29502 25.7092C6.2936 25.7078 6.29219 25.7064 6.29078 25.705C6.19595 25.6096 6.12432 25.4999 6.07588 25.3828C6.02699 25.2649 6 25.1356 6 25C6 24.9999 6 24.9999 6 24.9998V20.2C6 19.6477 6.44772 19.2 7 19.2C7.55228 19.2 8 19.6477 8 20.2V22.5858L12.2929 18.2929C12.6834 17.9024 13.3166 17.9024 13.7071 18.2929Z",
    fill: "#1F2025"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2 7C19.2 6.44772 19.6477 6 20.2 6H24.9998C24.9999 6 24.9999 6 25 6C25.1356 6 25.2649 6.02699 25.3828 6.07588C25.4999 6.12432 25.6096 6.19595 25.705 6.29078C25.7064 6.29219 25.7078 6.2936 25.7092 6.29502C25.804 6.3904 25.8757 6.50014 25.9241 6.61722C25.973 6.73512 26 6.86441 26 7V11.8C26 12.3523 25.5523 12.8 25 12.8C24.4477 12.8 24 12.3523 24 11.8V9.41421L19.7071 13.7071C19.3166 14.0976 18.6834 14.0976 18.2929 13.7071C17.9024 13.3166 17.9024 12.6834 18.2929 12.2929L22.5858 8H20.2C19.6477 8 19.2 7.55228 19.2 7Z",
    fill: "#1F2025"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.41421 8L13.7071 12.2929C14.0976 12.6834 14.0976 13.3166 13.7071 13.7071C13.3166 14.0976 12.6834 14.0976 12.2929 13.7071L8 9.41421V11.8C8 12.3523 7.55228 12.8 7 12.8C6.44772 12.8 6 12.3523 6 11.8V7.00017C6 7.00012 6 7.00006 6 7C6 6.74408 6.09763 6.48816 6.29289 6.29289C6.38877 6.19702 6.49927 6.12468 6.61722 6.07588C6.73512 6.02699 6.86441 6 7 6C7.00006 6 7.00012 6 7.00017 6H11.8C12.3523 6 12.8 6.44772 12.8 7C12.8 7.55228 12.3523 8 11.8 8H9.41421Z",
    fill: "#1F2025"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.16a01f6c77eafb7b113e2aef3ec18cff.svg";
export { ForwardRef as ReactComponent };